var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full_page"},[_c('WootHeatMap',{attrs:{"chartSeries":_vm.sales_reports,"onFilterSelect":_vm.onChangeMetric}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }